import { createAction } from 'redux-actions';

import types from './types';

const getStoreDetails = createAction(types.LOAD_STORE_DETAILS);
const setStoreDetails = createAction(types.SET_STORE_DETAILS);
const setError = createAction(types.SET_ERROR);

export default {
    getStoreDetails,
    setStoreDetails,
    setError,
};
